type CodeAssignment = {
    [key: number]: {
        class?: string
        value?: any
        text?: string
    }
}

// const materialCodes: CodeAssignment = {
//     1: {
//         text: "Kunststoff",
//     },
//     2: {
//         text: "Aluminium",
//     },
//     3: {
//         text: "Edelstahl",
//     },
// }

// const installationTypeCodes: CodeAssignment = {
//     1: {
//         text: "Unterputz",
//     },
//     2: {
//         text: "Aufputz",
//     },
//     3: {
//         text: "freistehend, einbetoniert",
//     },
//     4: {
//         text: "freistehend, aufgeschraubt",
//     },
//     5: {
//         text: "in Grenzmauer eingelassen",
//     },
//     6: {
//         text: "in Grenzmauer integriert",
//     },
// }

// const intercomBellCodes: CodeAssignment = {
//     1: {
//         text: "ohne Sprechfeld/Klingel",
//     },
//     2: {
//         text: "mit Sprechfeld/Klingel rechts",
//     },
//     3: {
//         text: "mit Sprechfeld/Klingel links",
//     },
//     4: {
//         text: "mit Sprechfeld/Klingel oben",
//     },
// }

const lineCodes: CodeAssignment = {
    1: {
        class: "tetro",
        text: "TETRO",
    },
    2: {
        class: "prisma",
        text: "PRISMA",
    },
    3: {
        class: "rs2000",
        text: "RS2000",
    },
    4: {
        class: "rs4000",
        text: "RS4000",
    },
    5: {
        class: "quadra",
        text: "QUADRA",
    },
    6: {
        class: "pf_round",
        text: "Putzrahmen rund",
    },
    7: {
        class: "pf_square",
        text: "Putzrahmen eckig",
    },
    8: {
        class: "pf_prisma",
        text: "Putzrahmen Prisma",
    },
    9: {
        class: "basic",
        text: "BASIC",
    },
    10: {
        class: "floater_frame",
        text: "Schattenfugenrahmen",
    },
    11: {
        class: "plan",
        text: "PLAN",
    },
}
export const lineData = (code: LineCode) => lineCodes[code] || { class: "unknown", text: "" }

// const postboxSizeCodes: CodeAssignment = {
//     1: {
//         text: "260 x 330 x 100",
//     },
//     2: {
//         text: "370 x 330 x 100",
//     },
//     3: {
//         text: "370 x 330 x 145",
//     },
//     4: {
//         text: "370 x 440 x 145",
//     },
//     // ...?
//     7: {
//         text: "300 x 440 x 160",
//     },
//     8: {
//         text: "400 x 440 x 160",
//     },
// }

// const surfaceCodes: CodeAssignment = {
//     1: {
//         text: "RAL",
//     },
//     2: {
//         text: "Edelstahl",
//     },
// }

export const deliveryTimeCodes: CodeAssignment = {
    1: {
        value: "2-3",
        text: "product.working-days",
    },
    2: {
        value: "5-10",
        text: "product.working-days",
    },
    3: {
        value: "10-15",
        text: "product.working-days",
    },
    4: {
        value: "15-20",
        text: "product.working-days",
    },
    5: {
        value: "3-4",
        text: "product.weeks",
    },
}
